import React, { useEffect } from "react";
import chatPerson from "../../../images/img/chat-person.png";

const MessageA2 = (props) => {
  const handleChange = (e) => {
    if (e.target.tagName === "SPAN") {
      props.handleClick(props.item.code);
      props.setTextOnClick("Emergency Top-up service");
    }
  };

  let text = props.item && props.item.text;
  text = text.replace(
    "Emergency Top-up service",
    '<span style="color:#e940ad;">Emergency Top-up service</a> '
  );

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div className="chat-person" style={{ marginTop: "10px" }}>
        <img src={chatPerson} alt="" />{" "}
      </div>
      <div
        className="chat-text"
        style={{ margin: "10px 0px" }}
        onClick={handleChange}
        aria-live="polite"
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    </div>
  );
};

export default MessageA2;
